export const productMetafieldSelection = [
  'ProductBadge',
  'ProductSegmentationBait',
  'ProductCategory',
  'ProductCancerReprTox',
  'ProductChemicals',
  'ProductHookBarbType',
  'ProductHookEye',
  'ProductHookEyeAngle',
  'ProductHookEyeTurn',
  'ProductHookFinish',
  'ProductHookLength',
  'ProductHookPoint',
  'ProductHookShank',
  'ProductHookShape',
  'ProductHookSubPoint',
  'ProductHookSubShank',
  'ProductHookTrademark',
  'ProductHookWeighted',
  'ProductHookWideGap',
  'ProductHookWire',
  'ProductHookWireStrength',
  'ProductLocation',
  'ProductLongDescription',
  'ProductName',
  'ProductProp65Comment',
  'ProductSeries',
  'ProductSizeChart',
  'ProductSizeStyle',
  'ProductShortDescription',
  'ProductStiffness',
  'ProductSubCategory',
  'ProductSegmentationSpecies',
  'ProductSegmentationTechnique',
  'ProductSegmentationWaterType',
  'ProductTrademark',
  'ProductVariantSelector',
  'ProductWarningColor',
  'ProductWarningType',
  'ProductWeedless',
  'ProductYotpoReviewCount',
  'ProductYotpoReviewScore',
];

export const productVariantMetafieldSelection = [
  'ItemColorName',
  'ItemDiameterSize',
  'ItemHookSize',
  'ItemLengthSize',
  'ItemPackCode',
  'ItemPackQuantity',
  'ItemRodAction',
  'ItemRodLureWeightSize',
  'ItemRodPower',
  'ItemRodSections',
  'ItemRodStyle',
  'ItemSize',
  'ItemTestRatingSize',
  'ItemWeightSize',
];
